import { MutationTree } from "vuex";
import { IApprovalWorkflow } from "@/core/interfaces/approvalWorkflow.interface";
import { IApprovalSystemState } from "../types";

const mutations: MutationTree<IApprovalSystemState> = {
  setApprovalWorkflows(state, payload: IApprovalWorkflow[]) {
    state.approvalWorkflows = payload;
  },
  setSelectedApprovalWorkflow(state, payload: IApprovalWorkflow | null) {
    state.selectedApprovalWorkflow = payload;
  },
  setFetchingApprovalWorkflows(state, payload: boolean) {
    state.isFetchingApprovalWorkflows = payload;
  },
  setFetchingApprovalWorkflowDetail(state, payload: boolean) {
    state.isFetchingApprovalWorkflowDetail = payload;
  },
  setApprovalWorkflowActionLoading(state, payload: boolean) {
    state.approvalWorkflowActionLoading = payload;
  },
};

export default mutations;
